export const environment = {
  production: false,
  API_BASE_URL: "https://opdracht-acc.opstoom.nl/api/",
  APP_BASE_URL: "https://opdracht-acc.opstoom.nl/",
  environment: "acc",
};